const resourcesAcionTypes = {
  GET_RESOURCE: "GET_RESOURCE",
  GET_RESOURCE_SUCCESS: "GET_RESOURCE_SUCCESS",
  GET_RESOURCE_FAIL: "GET_RESOURCE_FAIL",
};

export default resourcesAcionTypes;
